import { render } from "./Data-management-service.vue?vue&type=template&id=1b240f78&scoped=true"
import script from "./Data-management-service.vue?vue&type=script&lang=js"
export * from "./Data-management-service.vue?vue&type=script&lang=js"

import "./Data-management-service.vue?vue&type=style&index=0&id=1b240f78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b240f78"]])

export default __exports__